export default angular
  .module('app.directives.meta', [])
  .directive('uMeta', () => ({
    restrict: 'E',
    scope: true,
    link(scope, element, attrs) {
      const { content, name, property } = attrs;
      const { head } = document;

      if (!document.querySelector(`meta[name="${name}"]`)) {
        const meta = document.createElement('meta');
        meta.setAttribute('name', name);
        meta.setAttribute('property', property);
        meta.setAttribute('content', content);
        head.appendChild(meta);
      }
    },
  }));
